import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10 18.773V11.23c0-.06.024-.112.073-.156A.255.255 0 0 1 10.25 11h.688c.065 0 .122.024.17.072a.2.2 0 0 1 .08.157v2.745c0 .03.012.045.036.045a.087.087 0 0 0 .061-.022l2.418-2.88a.35.35 0 0 1 .079-.072c.04-.03.105-.045.195-.045h.688c.118 0 .199.048.244.145a.24.24 0 0 1-.03.268l-2.845 3.326a.276.276 0 0 0-.073.134c-.008.04.012.087.06.14l3.192 3.565c.04.048.06.102.06.162a.343.343 0 0 1-.017.106c-.037.104-.126.156-.268.156h-.786c-.093 0-.156-.013-.189-.039a1.716 1.716 0 0 1-.085-.072l-2.643-3.03a.087.087 0 0 0-.06-.023c-.025 0-.037.015-.037.045v2.89c0 .06-.027.114-.08.162a.244.244 0 0 1-.17.067h-.688a.266.266 0 0 1-.177-.067.223.223 0 0 1-.073-.162Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M8.5 7.5h-5l-1 16h19l-1-16h-5m-7 0V4a3.5 3.5 0 1 1 7 0v3.5m-7 0h7",
  stroke: "currentColor",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }